import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "dashboard",
  "use": "dashboard-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 14\" id=\"dashboard\"><g fill-rule=\"nonzero\"><path d=\"M0 0h16v4H0zM0 5h7v9H0zM8 5h8v4H8zM8 10h8v4H8z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id